// 業種マスタ一覧画面
import React, { useState, useEffect, useCallback } from 'react';
import { useMediaQuery, Button, Grid, Snackbar } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import { Redirect } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  isLoggedIn,
  mainBlueColor,
  btnColor,
  userMenuId
} from '../GlobalState';
import {
  createPartnerCategoryDetailItems,
  createPartnerCategoryItems,
  deleteCategoryDetailItemById,
  deleteCategoryItemById,
  getPartnerCategories,
  sortPartnerCategoryItems,
  updatePartnerCategoryDetailItems,
  updatePartnerCategoryItems
} from '../apicalls/partnerCategory';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import AddIcon from '@material-ui/icons/Add';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { Item } from '../components/partnerCategory/Item';
import { DeleteModal } from '../components/partnerCategory/DeleteModal';
import { UpdateModal } from '../components/partnerCategory/UpdateModal';
import { CreateModal } from '../components/partnerCategory/CreateModal';
import { TCategoryItem } from '../types/partnerCategory';
import { reorder, moveList } from '../utils/dragAndDrop';

export const PartnerCategoryPage: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      pageTitle: {
        fontWeight: 'bold',
        paddingTop: 30,
        paddingLeft: 30
      },
      createBottomArea: {
        position: 'sticky',
        top: 120,
        zIndex: 10,
        display: 'flex',
        justifyContent: 'flex-end',
        backgroundColor: '#FFFFFF',
        padding: '30px 30px',
        borderBottom: '1px #F5F5F5 solid'
      },
      listHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        color: '#FFF',
        backgroundColor: `${mainColor}`,
        height: 60
      },
      headerText: {
        marginLeft: 60
      }
    })
  );

  const classes = useStyles();
  const matches2 = useMediaQuery('(min-width:900px)');
  const [userMenu] = useRecoilState<any>(userMenuId);
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  // 業種一覧を格納
  const [categoryItems, setCategoryItems] = useState<TCategoryItem[]>([]);
  // クリックした項目を格納
  const [selectItem, setSelectItem] = useState<TCategoryItem>({
    id: 0,
    name: '',
    registered: 0
  });
  // モーダル開閉時に大項目・小項目を判定するフラグ
  const [detailItemFlg, setDetailItemFlg] = useState<boolean>(false);
  // 各モーダルの開閉
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  /**
   * カテゴリ全取得
   */
  const getAllPartnerCategories = () => {
    getPartnerCategories().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setCategoryItems(data.data);
          }
        }
      }
    });
  };

  /**
   * 並び替え保存
   */
  const sortItems = (items: TCategoryItem[]) => {
    const order_list: any = [];
    items.forEach((item: TCategoryItem) => {
      const detail_list: number[] = [];
      if (item.category_detail && item.category_detail.length > 0) {
        item.category_detail.forEach((detail: any) => {
          detail_list.push(detail.id);
        });
      }
      const itemIdObj = { [item.id]: detail_list };
      order_list.push(itemIdObj);
    });
    sortPartnerCategoryItems(order_list).then(data => {
      if (data === 'Not logged in!') {
        <Redirect to='/' />;
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setSuccessMessage(data.message);
            setOpenSuccess(true);
            getAllPartnerCategories();
          }
        }
      }
    });
  };

  /**
   * 新規作成
   */
  const createItem = (
    detialItemFlg: boolean,
    name: string,
    partner_category_id?: any
  ) => {
    if (detialItemFlg) {
      // 小項目の場合
      createPartnerCategoryDetailItems(name, partner_category_id).then(data => {
        if (data === 'Not logged in!') {
          <Redirect to='/' />;
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setSuccessMessage(data.message);
              setOpenSuccess(true);
              getAllPartnerCategories();
            }
          }
        }
      });
    } else {
      // 大項目の場合
      createPartnerCategoryItems(name).then(data => {
        if (data === 'Not logged in!') {
          <Redirect to='/' />;
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setSuccessMessage(data.message);
              setOpenSuccess(true);
              getAllPartnerCategories();
            }
          }
        }
      });
    }
  };

  /**
   * 更新
   */
  const updateItem = (
    detialItemFlg: boolean,
    id: number,
    name: string,
    partner_category_id?: any
  ) => {
    if (detialItemFlg) {
      // 小項目の場合
      updatePartnerCategoryDetailItems(id, name, partner_category_id).then(
        data => {
          if (data === 'Not logged in!') {
            <Redirect to='/' />;
          } else {
            if (typeof data === 'string') {
              setErrorMessage(data);
              setOpen(true);
            } else {
              if (data.error) {
                setErrorMessage(data.error);
                setOpen(true);
              } else {
                setSuccessMessage(data.message);
                setOpenSuccess(true);
                getAllPartnerCategories();
              }
            }
          }
        }
      );
    } else {
      // 大項目の場合
      updatePartnerCategoryItems(id, name).then(data => {
        if (data === 'Not logged in!') {
          <Redirect to='/' />;
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setSuccessMessage(data.message);
              setOpenSuccess(true);
              getAllPartnerCategories();
            }
          }
        }
      });
    }
  };

  /**
   * 項目削除
   */
  const deleteItem = (detialItemFlg: boolean, itemId: number) => {
    if (detialItemFlg) {
      // 小項目の場合
      deleteCategoryDetailItemById(itemId).then(data => {
        if (data === 'Not logged in!') {
          <Redirect to='/' />;
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setSuccessMessage(data.message);
              setOpenSuccess(true);
              getAllPartnerCategories();
            }
          }
        }
      });
    } else {
      // 大項目の場合
      deleteCategoryItemById(itemId).then(data => {
        if (data === 'Not logged in!') {
          <Redirect to='/' />;
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setSuccessMessage(data.message);
              setOpenSuccess(true);
              getAllPartnerCategories();
            }
          }
        }
      });
    }
  };

  /**
   * 項目をドロップした時に発動
   */
  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    // 出発点のindex
    const startIndex = result.source.index;
    // 着地点のindex
    const endIndex = result.destination.index;

    // 出発点のdroppableId
    const startDroppableId = result.source.droppableId;
    // 着地点のdroppableId
    const endDroppableId = result.destination.droppableId;

    // 大項目の入れ替え
    if (result.type === 'large') {
      reorder(categoryItems, startIndex, endIndex);
    } else {
      // droppableIdからリストのindexを取得
      const startArrayIndex = Number(startDroppableId.split('-')[1]);
      const endArrayIndex = Number(endDroppableId.split('-')[1]);

      // 同じリスト内の場合
      if (startDroppableId === endDroppableId) {
        reorder(
          categoryItems[startArrayIndex].category_detail,
          startIndex,
          endIndex
        );
      } else {
        // 項目跨ぎの場合
        moveList(
          categoryItems[startArrayIndex].category_detail,
          categoryItems[endArrayIndex].category_detail,
          startIndex,
          endIndex
        );
      }
    }
    setCategoryItems(categoryItems);
    sortItems(categoryItems);
  };

  useEffect(() => {
    getAllPartnerCategories();
  }, []);

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='partner_categories' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          {openSuccess ? (
            <Snackbar
              open={openSuccess}
              autoHideDuration={2000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {successMessage}
              </Alert>
            </Snackbar>
          ) : null}

          {/* 更新モーダル */}
          <CreateModal
            selectItem={selectItem}
            detailItemFlg={detailItemFlg}
            createModal={createModal}
            setCreateModal={setCreateModal}
            createItem={createItem}
          />
          {/* 更新モーダル */}
          <UpdateModal
            categoryItems={categoryItems}
            selectItem={selectItem}
            detailItemFlg={detailItemFlg}
            updateModal={updateModal}
            setUpdateModal={setUpdateModal}
            updateItem={updateItem}
          />
          {/* 削除モーダル */}
          <DeleteModal
            selectItem={selectItem}
            deleteModal={deleteModal}
            detailItemFlg={detailItemFlg}
            setDeleteModal={setDeleteModal}
            deleteItem={deleteItem}
          />

          <div className={matches2 ? 'main-container-customer' : ''}>
            <div></div>
            <div
              className={
                matches2
                  ? 'top-Container-customer'
                  : 'top-Container-customer-responsive'
              }
            ></div>
          </div>

          <div style={{ backgroundColor: '#FFFFFF', borderRadius: 5 }}>
            <div className='table-top-container-customer'>
              <div className={classes.pageTitle}>業種マスタ</div>
            </div>
            {/* 新規作成ボタン */}
            <div className={classes.createBottomArea}>
              <Button
                style={{
                  backgroundColor: buttonColor,
                  marginRight: 10,
                  marginBottom: !matches2 ? 10 : 0
                }}
                variant='contained'
                color='secondary'
                startIcon={<AddIcon />}
                onClick={() => {
                  setDetailItemFlg(false);
                  setCreateModal(true);
                }}
              >
                大項目追加
              </Button>
            </div>

            {/* 一覧表示 */}
            <div style={{ padding: '0px 20px' }}>
              {/* ヘッダー */}
              <Grid container className={classes.container}>
                <Grid item xs={12} className={classes.listHeader}>
                  <Grid container>
                    <Grid item xs={3} className={classes.headerText}>
                      大項目
                    </Grid>
                    <Grid item xs={6} className={classes.headerText}>
                      小項目
                    </Grid>
                  </Grid>
                </Grid>
                {/* 項目 */}
                <Grid item xs={12}>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId='droppable' type='large'>
                      {provided => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {categoryItems &&
                            categoryItems.map(
                              (item: TCategoryItem, index: any) => (
                                // 大項目
                                <Item
                                  item={item}
                                  index={index}
                                  setSelectItem={setSelectItem}
                                  detailItemFlg={detailItemFlg}
                                  setDetailItemFlg={setDetailItemFlg}
                                  setCreateModal={setCreateModal}
                                  setUpdateModal={setUpdateModal}
                                  setDeleteModal={setDeleteModal}
                                  handleCloseSuccess={handleCloseSuccess}
                                />
                              )
                            )}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
